// extracted by mini-css-extract-plugin
module.exports = {"layout__content":"Layout_layout__content__D83Cr","layout__content_sizer":"Layout_layout__content_sizer__2AIas","layout__footer":"Layout_layout__footer__18B05"};